let Parameters = {
	aliases: {
		activated: 'act',
		active: 'ac',
		affiliate: 'fflt',
		allow: 'al',
		application_partners: 'ap',
		approval: 'apl',
		area_ids: 'ae',
		area_presence: 'aep',
		article_ids: 'ar',
		assistant_ids: 'ai',
		auditor_ids: 'au',
		banner_boxes: 'bb',
		banner_ids: 'ba',
		body_ids: 'bo',
		brand: 'br',
		cae_max: 'caex',
		cae_min: 'caem',
		campaign_ids: 'cam',
		capped_budget: 'cb',
		category_ids: 'ca',
		chain_types: 'ct',
		child_ids: 'chi',
		city_ids: 'ti',
		classifications: 'cl',
		cms_user_id: 'cmi',
		comparison_ids: 'cmp',
		consortium_ids: 'mi',
		continents: 'con',
		country_ids: 'ci',
		country_status: 'cs',
		course_ids: 'co',
		cpm_max: 'cx',
		cpm_min: 'cm',
		date_max: 'dax',
		date_min: 'dam',
		date_type: 'dat',
		degrees: 'dg',
		density: 'de',
		discipline_ids: 'di',
		distance: 'dt',
		double_reports: 'dr',
		duration_max: 'dx',
		duration_min: 'dm',
		duration_ranges: 'dur',
		education_levels: 'elv',
		educational_forms: 'ef',
		email: 'ma',
		email_like: 'mal',
		entity: 'et',
		entity_ids: 'eid',
		entity_types: 'ety',
		entropy: 'en',
		entry_level: 'el',
		entry_level_max: 'elx',
		entry_level_min: 'elm',
		exact_name: 'xna',
		exact_query: 'equ',
		executive: 'xu',
		experience_ids: 'ex',
		external: 'ext',
		facebook_id: 'fb',
		favourite_ids: 'fvr',
		favourited: 'fav',
		fce_max: 'fcex',
		fce_min: 'fcem',
		filename: 'fn',
		from_area_ids: 'fae',
		from_city_ids: 'fci',
		from_country_ids: 'fco',
		from_organisation_ids: 'for',
		from_region_ids: 'frg',
		from_study_ids: 'fst',
		from_user_ids: 'fus',
		full_name: 'fna',
		full_name_email: 'fne',
		genders: 'ge',
		godmode: 'god',
		group_ids: 'gi',
		group_size_max: 'gsx',
		group_size_min: 'gsm',
		handler_ids: 'hi',
		has_adwords: 'had',
		has_banner: 'hb',
		has_english_courses: 'hec',
		has_experience: 'hex',
		has_inquiry_campaign: 'hic',
		has_language_courses: 'hlco',
		has_language_courses_types: 'hlcot',
		has_language_studies: 'hlst',
		has_lead_campaign: 'hlc',
		has_organisations: 'hor',
		has_reviews: 'hre',
		has_venues: 'hve',
		hash: 'ha',
		highlight: 'hl',
		ids: 'id',
		ielts_max: 'ieltsx',
		ielts_min: 'ieltsm',
		in_ranking: 'rk',
		intensity_max: 'ix',
		intensity_min: 'im',
		invert: 'iv',
		ip: 'ip',
		is_student: 'is',
		iso_code: 'iso',
		joint: 'jt',
		keywords: 'kw',
		kinds: 'ki',
		language: 'lan',
		language_course_ids: 'lco',
		language_ids: 'ln',
		latitude: 'la',
		lead_campaign_ids: 'ldc',
		legacy: 'lgc',
		legacy_ids: 'leg',
		level: 'lev',
		levels: 'lv',
		locale: 'lc',
		locales: 'lcs',
		locations: 'loc',
		longitude: 'lo',
		mailing_type_ids: 'mty',
		manager_ids: 'mid',
		member_student_ids: 'msi',
		methods: 'mh',
		mobility_types: 'mt',
		name: 'na',
		no_countries: 'nci',
		no_disciplines: 'ndi',
		no_duration_max: 'ndx',
		no_duration_min: 'ndm',
		no_from_countries: 'nfc',
		no_levels: 'nlv',
		no_options: 'nop',
		no_purposes: 'npp',
		no_users: 'nus',
		not_country_ids: '!ci',
		not_degrees: '!dg',
		not_send: 'ns',
		now: 'now',
		occurrence_ids: 'oc',
		options: 'op',
		organisation_ids: 'oi',
		over_budget: 'ob',
		page: 'pa',
		parent_ids: 'pi',
		partial_reports: 'plr',
		parttime_variants: 'pv',
		person_ids: 'ps',
		personal_updates: 'per',
		population_max: 'pox',
		population_min: 'pom',
		portal_types: 'pt',
		premiums: 'pm',
		preparation_course_ids: 'pco',
		presence: 'pr',
		product_ids: 'pro',
		project_types: 'prj',
		public: 'pb',
		purpose: 'pu',
		purposes: 'pp',
		qualified: 'qa',
		query: 'qu',
		ranking_ids: 'ra',
		ratings: 'rts',
		rbp: 'rbp',
		recommended_ids: 'rec',
		recursive: 'rv',
		referred_student_ids: 'rsi',
		region_ids: 'rg',
		regions: 'rgs',
		related_ids: 'rel',
		relations: 'rl',
		report_ids: 'ri',
		responsive: 'res',
		review_ids: 'rw',
		rolling: 'rol',
		scholarship_ids: 'sc',
		search_variation: 'sv',
		show_areas: 'sa',
		site_ids: 'sid',
		skills: 'sk',
		special_programmes: 'sps',
		spl: 'sp',
		spotlight: 'spl',
		start_dates: 'sd',
		startdate_ids: 'sta',
		statuses: 'ss',
		student_ids: 'su',
		student_organisation_ids: 'so',
		study_deadline_ids: 'sdl',
		study_ids: 'st',
		study_relation: 'sr',
		studyportals: 'prtl',
		sublevel: 'sl',
		subscribed: 'sub',
		subscription_ids: 'sb',
		tags: 'tg',
		tail: 'tail',
		target_ids: 'ta',
		terms: 'te',
		title: 'til',
		to_area_ids: 'tae',
		to_city_ids: 'tci',
		to_country_ids: 'tco',
		to_organisation_ids: 'tor',
		to_region_ids: 'trg',
		to_study_ids: 'tst',
		to_user_ids: 'tus',
		toefl_internet_max: 'toeflix',
		toefl_internet_min: 'toeflim',
		toefl_paper_max: 'toeflpx',
		toefl_paper_min: 'toeflpm',
		topic: 'to',
		topic_ids: 'tpc',
		toplevel: 'tl',
		tuition_fee_currency: 'tc',
		tuition_fee_max: 'tx',
		tuition_fee_min: 'tm',
		tuition_fee_target: 'tt',
		tuition_fee_unit: 'tu',
		tuition_ranges: 'tr',
		type: 'tp',
		types: 'ty',
		uni_admin_users: 'uau',
		uniqueid: 'uid',
		url: 'url',
		user_agent: 'ua',
		user_country: 'uc',
		user_ids: 'us',
		user_region: 'ur',
		venue_ids: 'vn',
		webinar_ids: 'wi',
		year: 'yr'
	},
	types: {
		activated: 'boolean',
		active: 'boolean',
		affiliate: 'string',
		allow: 'boolean',
		application_partners: 'boolean',
		approval: 'boolean',
		area_ids: 'integer[]',
		area_presence: 'string[]',
		article_ids: 'integer[]',
		assistant_ids: 'integer[]',
		auditor_ids: 'integer[]',
		banner_boxes: 'string[]',
		banner_ids: 'integer[]',
		body_ids: 'integer[]',
		brand: 'string',
		cae_max: 'integer',
		cae_min: 'integer',
		campaign_ids: 'integer[]',
		capped_budget: 'boolean',
		category_ids: 'integer[]',
		chain_types: 'string[]',
		child_ids: 'integer[]',
		city_ids: 'integer[]',
		classifications: 'string[]',
		cms_user_id: 'integer',
		comparison_ids: 'integer[]',
		consortium_ids: 'integer[]',
		continents: 'boolean',
		country_ids: 'integer[]',
		country_status: 'string[]',
		course_ids: 'integer[]',
		cpm_max: 'integer',
		cpm_min: 'integer',
		date_max: 'timestamp',
		date_min: 'timestamp',
		date_type: 'string',
		degrees: 'string[]',
		density: 'string[]',
		discipline_ids: 'integer[]',
		distance: 'string',
		double_reports: 'boolean',
		duration_max: 'integer',
		duration_min: 'integer',
		duration_ranges: 'range[]',
		education_levels: 'string[]',
		educational_forms: 'string[]',
		email: 'string',
		email_like: 'string',
		entity: 'string',
		entity_ids: 'integer[]',
		entity_types: 'string[]',
		entropy: 'integer',
		entry_level: 'string',
		entry_level_max: 'string',
		entry_level_min: 'string',
		exact_name: 'string',
		exact_query: 'string',
		executive: 'boolean',
		experience_ids: 'integer[]',
		external: 'string',
		facebook_id: 'string',
		favourite_ids: 'integer[]',
		favourited: 'boolean',
		fce_max: 'integer',
		fce_min: 'integer',
		filename: 'string',
		from_area_ids: 'integer[]',
		from_city_ids: 'integer[]',
		from_country_ids: 'integer[]',
		from_organisation_ids: 'integer[]',
		from_region_ids: 'integer[]',
		from_study_ids: 'integer[]',
		from_user_ids: 'integer[]',
		full_name: 'string',
		full_name_email: 'string',
		genders: 'string[]',
		godmode: 'boolean',
		group_ids: 'integer[]',
		group_size_max: 'integer',
		group_size_min: 'integer',
		handler_ids: 'integer[]',
		has_adwords: 'boolean',
		has_banner: 'boolean',
		has_english_courses: 'boolean',
		has_experience: 'boolean',
		has_inquiry_campaign: 'boolean',
		has_language_courses: 'boolean',
		has_language_courses_types: 'string[]',
		has_language_studies: 'boolean',
		has_lead_campaign: 'boolean',
		has_organisations: 'boolean',
		has_reviews: 'boolean',
		has_venues: 'boolean',
		hash: 'string',
		highlight: 'boolean',
		ids: 'integer[]',
		ielts_max: 'string',
		ielts_min: 'string',
		in_ranking: 'boolean',
		intensity_max: 'integer',
		intensity_min: 'integer',
		invert: 'boolean',
		ip: 'string',
		is_student: 'boolean',
		iso_code: 'string',
		joint: 'string[]',
		keywords: 'string',
		kinds: 'string[]',
		language: 'string',
		language_course_ids: 'integer[]',
		language_ids: 'integer[]',
		latitude: 'string',
		lead_campaign_ids: 'integer[]',
		legacy: 'boolean',
		legacy_ids: 'integer[]',
		level: 'string',
		levels: 'string[]',
		locale: 'string',
		locales: 'string[]',
		locations: 'string[]',
		longitude: 'string',
		mailing_type_ids: 'integer[]',
		manager_ids: 'integer[]',
		member_student_ids: 'integer[]',
		methods: 'string[]',
		mobility_types: 'string[]',
		name: 'string',
		no_countries: 'boolean',
		no_disciplines: 'boolean',
		no_duration_max: 'boolean',
		no_duration_min: 'boolean',
		no_from_countries: 'boolean',
		no_levels: 'boolean',
		no_options: 'string[]',
		no_purposes: 'boolean',
		no_users: 'boolean',
		not_country_ids: 'integer[]',
		not_degrees: 'string[]',
		not_send: 'boolean',
		now: 'timestamp',
		occurrence_ids: 'integer[]',
		options: 'string[]',
		organisation_ids: 'integer[]',
		over_budget: 'boolean',
		page: 'string',
		parent_ids: 'integer[]',
		partial_reports: 'boolean',
		parttime_variants: 'string[]',
		person_ids: 'integer[]',
		personal_updates: 'boolean',
		population_max: 'string',
		population_min: 'string',
		portal_types: 'string[]',
		premiums: 'string[]',
		preparation_course_ids: 'integer[]',
		presence: 'string[]',
		product_ids: 'integer[]',
		project_types: 'string[]',
		public: 'boolean',
		purpose: 'string',
		purposes: 'string[]',
		qualified: 'boolean',
		query: 'string',
		ranking_ids: 'integer[]',
		ratings: 'string[]',
		rbp: 'boolean',
		recommended_ids: 'integer[]',
		recursive: 'boolean',
		referred_student_ids: 'integer[]',
		region_ids: 'integer[]',
		regions: 'string[]',
		related_ids: 'integer[]',
		relations: 'string[]',
		report_ids: 'integer[]',
		responsive: 'boolean',
		review_ids: 'integer[]',
		rolling: 'boolean',
		scholarship_ids: 'integer[]',
		search_variation: 'integer',
		show_areas: 'boolean',
		site_ids: 'integer[]',
		skills: 'string[]',
		special_programmes: 'string[]',
		spl: 'boolean',
		spotlight: 'boolean',
		start_dates: 'string[]',
		startdate_ids: 'integer[]',
		statuses: 'string[]',
		student_ids: 'integer[]',
		student_organisation_ids: 'integer[]',
		study_deadline_ids: 'integer[]',
		study_ids: 'integer[]',
		study_relation: 'boolean',
		studyportals: 'boolean',
		sublevel: 'boolean',
		subscribed: 'boolean',
		subscription_ids: 'integer[]',
		tags: 'string[]',
		tail: 'boolean',
		target_ids: 'integer[]',
		terms: 'string[]',
		title: 'string',
		to_area_ids: 'integer[]',
		to_city_ids: 'integer[]',
		to_country_ids: 'integer[]',
		to_organisation_ids: 'integer[]',
		to_region_ids: 'integer[]',
		to_study_ids: 'integer[]',
		to_user_ids: 'integer[]',
		toefl_internet_max: 'integer',
		toefl_internet_min: 'integer',
		toefl_paper_max: 'integer',
		toefl_paper_min: 'integer',
		topic: 'string',
		topic_ids: 'integer[]',
		toplevel: 'boolean',
		tuition_fee_currency: 'string',
		tuition_fee_max: 'integer',
		tuition_fee_min: 'integer',
		tuition_fee_target: 'string',
		tuition_fee_unit: 'string',
		tuition_ranges: 'range[]',
		type: 'string',
		types: 'string[]',
		uni_admin_users: 'boolean',
		uniqueid: 'string',
		url: 'string',
		user_agent: 'string',
		user_country: 'integer',
		user_ids: 'integer[]',
		user_region: 'integer',
		venue_ids: 'integer[]',
		webinar_ids: 'integer[]',
		year: 'integer'
	},

	/**
	 * Turn a parameter array into a string.
	 *
	 * @param {object} parameterArray
	 * @return string
	 */

	alias(parameterArray) {
		if (typeof parameterArray !== 'object') {
			console.warn('Parameter array is not an array.');
			return '';
		}

		if (parameterArray.length === 0) {
			console.warn('No parameters to alias.');
			return '';
		}

		let aliased = [];
		let self = this;

		parameterArray = this._sort(parameterArray);

		Object.keys(parameterArray).map(function (key) {
			let value = parameterArray[key];

			switch (self._getType(key)) {
				case 'string[]':
					try {
						aliased.push(self._serializeStringArray(key, value));
					} catch (err) {
						console.warn('Serialization for ' + key + ' failed: ' + err);
					}
					break;

				case 'integer[]':
					try {
						aliased.push(self._serializeIntegerArray(key, value));
					} catch (err) {
						console.warn('Serialization for ' + key + ' failed: ' + err);
					}
					break;

				case 'range[]':
					try {
						aliased.push(self._serializeRangeArray(key, value));
					} catch (err) {
						console.warn('Serialization for ' + key + ' failed: ' + err);
					}
					break;

				case 'string':
					if (typeof value !== 'string') {
						value = '';
					}

					value = value.trim();

					if (value !== '') {
						aliased.push(self._getShortName(key) + '-' + value);
					} else {
						console.warn('Value "' + value + '" in key ' + key + ' is an empty string!');
					}
					break;

				case 'integer':
					value = parseInt(value, 10);

					if (!isNaN(value)) {
						aliased.push(self._getShortName(key) + '-' + value);
					} else {
						console.warn('Value ' + value + ' in key ' + key + ' is not a number!');
					}
					break;

				case 'boolean':
					if (value) {
						aliased.push(self._getShortName(key) + '-' + '1');
					} else {
						aliased.push(self._getShortName(key) + '-' + '0');
					}
					break;

				case 'timestamp':
					try {
						value = self._parseTimeStamp(value);
						aliased.push(self._getShortName(key) + '-' + value);
					} catch (err) {
						console.warn('Could not parse timestamp for ' + key);
					}

					break;

				default:
					console.warn('Could not resolve type for ' + key);
					break;
			}
		});

		if (aliased.length === 0) {
			console.warn('Could not generate aliased string.');
			return '';
		}

		return aliased.join('|');
	},

	/**
	 * Turn a string into a parameter array.
	 *
	 * @param {string} aliasedString
	 * @return object
	 */

	unalias(aliasedString) {
		if (typeof aliasedString !== 'string') {
			console.warn('Parameters.unalias: Cannot un-alias string!');
			return {};
		}

		// Sorting works by virtue of the format of the aliased string.

		let components = aliasedString.split('|');
		components.sort();

		let parameterArray = {};

		let self = this;

		components.map(function (item) {
			let composite = item.split('-');
			let alias = composite.shift();
			let value = composite.join('-');

			let longName = self._getLongName(alias);

			if (longName === '') {
				console.warn('Full name for ' + alias + ' not found!');
				return;
			}

			let type = self._getType(longName);

			if (type === '') {
				console.warn('Type for ' + longName + ' not found!');
				return;
			}

			switch (type) {
				case 'string[]':
					try {
						parameterArray[longName] = self._unserializeStringArray(value);
					} catch (err) {
						console.warn('Could not unserialize ' + longName);
						return;
					}
					break;

				case 'integer[]':
					try {
						parameterArray[longName] = self._unserializeIntegerArray(value);
					} catch (err) {
						console.warn('Could not unserialize ' + longName);
						return;
					}
					break;

				case 'range[]':
					try {
						parameterArray[longName] = self._unserializeRangeArray(value);
					} catch (err) {
						console.warn('Could not unserialize ' + longName);
						return;
					}
					break;

				case 'string':
					parameterArray[longName] = value;
					break;

				case 'integer':
					if (!isNaN(parseInt(value, 10))) {
						parameterArray[longName] = value;
					}
					break;

				case 'boolean':
					parameterArray[longName] = false;
					if (value) {
						parameterArray[longName] = true;
					}
					break;

				default:
					console.warn(longName + ' not unserialized, ' + 'type ' + type + ' not implemented.');
					break;
			}
		});

		return parameterArray;
	},

	/**
	 * Sort parameters so they're always in the same order.
	 *
	 * @param {object} parameterArray
	 * @returns {object}
	 */

	_sort(parameterArray) {
		let keys = [];
		Object.keys(parameterArray).map(function (key) {
			keys.push(key);
		});

		keys.sort();
		let sorted = {};

		keys.map(function (key) {
			sorted[key] = parameterArray[key];
		});

		return sorted;
	},

	/**
	 * Unserialize a serialized string array.
	 *
	 * @param {string} value
	 * @returns object
	 * @throws Error
	 */

	_unserializeStringArray(value) {
		let split = value.split(',');

		let clean = [];

		split.map(function (item) {
			let str = item.trim();

			if (str !== '') {
				clean.push(str);
			}
		});

		if (clean.length === 0) {
			throw new Error('Parameters._unserializeStringArray: clean array is empty');
		}

		return clean;
	},

	/**
	 * Unserialize a serialized integer array.
	 *
	 * @param {string} value
	 * @returns object
	 * @throws Error
	 */

	_unserializeIntegerArray(value) {
		let split = value.split(',');

		let clean = [];

		split.map(function (item) {
			let num = parseInt(item, 10);

			if (!isNaN(num)) {
				clean.push(num);
			}
		});

		if (clean.length === 0) {
			throw new Error('Parameters._unserializeIntegerArray: empty clean array!');
		}

		return clean;
	},

	/**
	 * Serialize a range array.
	 *
	 * A range array is an array containing arrays.
	 *
	 * @param {string} key
	 * @param {string} value
	 * @returns string
	 * @throws Error
	 */

	_serializeRangeArray(key, value) {
		if (this._getShortName(key) === '') {
			console.warn('Parameters._serializeRangeArray: No alias found for ' + key + '!');
			throw new Error('No alias found for ' + key + '!');
		}

		if (value instanceof Array !== true) {
			console.warn('Parameters._serializeRangeArray: Not an array!');
			throw new Error('Not an array!');
		}

		if (value.length === 0) {
			console.warn('Parameters._serializeRangeArray: Empty array!');
			throw new Error('Empty array!');
		}

		let clean = [];

		value.map(function (range) {
			if (range instanceof Array === false) {
				console.warn('Parameters._serializeRangeArray: Range not an array!');
				throw new Error('Range not an array!');
			}

			let cleanRange = [];
			range.map(function (item) {
				let num = parseInt(item, 10);
				if (isNaN(num)) {
					console.warn('Parameters._serializeRangeArray: Range value is not a number!');
					throw new Error('Range value is not a number!');
				}

				cleanRange.push(num);
			});
			clean.push('[' + cleanRange.join(',') + ']');
		});

		if (clean.length === 0) {
			console.warn('Parameters._serializeIntegerArray: Empty clean array!');
			throw new Error('Empty clean array!');
		}

		return this._getShortName(key) + '-' + clean.join(',');
	},

	/**
	 * Unserialize a serialized range array.
	 *
	 * <p>A serialized range array can look like [500,1000],[1000,5000],[5000,10000].</p>
	 *
	 * @param {string} value
	 * @returns object
	 * @throws Error
	 */

	_unserializeRangeArray(value) {
		value = '[' + value + ']';

		let ranges = [];

		try {
			ranges = JSON.parse(value);
		} catch (error) {
			console.log(error);

			throw new Error('Parameters._unserializeRangeArray: incorrect range format!');
		}

		if (!(ranges instanceof Array)) {
			throw new Error('Parameters._unserializeRangeArray: ranges is not an array!');
		}

		if (ranges.length === 0) {
			throw new Error('Parameters._unserializeRangeArray: nothing found in ranges!');
		}

		let clean = [];
		ranges.map(function (range) {
			if (range.length !== 2) {
				throw new Error('Parameters._unserializeRangeArray: single range should have two values!');
			}

			let cleanValues = [];
			range.map(function (number) {
				cleanValues.push(parseInt(number, 10));
			});

			clean.push(cleanValues);
		});

		return clean;
	},

	/**
	 * Serialize an integer array.
	 *
	 * @param {string} key
	 * @param {string} value
	 * @returns string
	 * @throws Error
	 */

	_serializeIntegerArray(key, value) {
		if (this._getShortName(key) === '') {
			console.warn('Parameters._serializeIntegerArray: No alias found for ' + key + '!');
			throw new Error('No alias found for ' + key + '!');
		}

		if (!(value instanceof Array)) {
			console.warn('Parameters._serializeIntegerArray: Not an array!');
			throw new Error('Not an array!');
		}

		if (value.length === 0) {
			console.warn('Parameters._serializeIntegerArray: Empty array!');
			throw new Error('Empty array!');
		}

		let clean = [];

		value.map(function (item) {
			let num = parseInt(item, 10);

			if (!isNaN(num)) {
				clean.push(num);
			}
		});

		if (clean.length === 0) {
			console.warn('Parameters._serializeIntegerArray: Empty clean array!');
			throw new Error('Empty clean array!');
		}

		return this._getShortName(key) + '-' + clean.join(',');
	},

	/**
	 * Serialize a string array.
	 *
	 * @param {string} key
	 * @param {string} value
	 * @returns string
	 * @throws Error
	 */

	_serializeStringArray(key, value) {
		if (this._getShortName(key) === '') {
			console.warn('Parameters._serializeStringArray: No alias found for ' + key + '!');
			throw new Error('No alias found for ' + key + '!');
		}

		if (!(value instanceof Array)) {
			console.warn('Parameters._serializeStringArray: Not an array!');
			throw new Error('Not an array!');
		}

		if (value.length === 0) {
			console.warn('Parameters._serializeStringArray: Empty array!');
			throw new Error('Empty array!');
		}

		let clean = [];

		value.map(function (item) {
			let str = item.trim();

			if (str !== '') {
				clean.push(str);
			}
		});

		if (clean.length === 0) {
			console.warn('Parameters._serializeStringArray: Empty clean array!');
			throw new Error('Empty clean array!');
		}

		return this._getShortName(key) + '-' + clean.join(',');
	},

	/**
	 * Determine the key type for a given long name.
	 *
	 * @param key
	 * @returns {string}
	 */

	_getType(key) {
		if (typeof this.types[key] !== 'undefined') {
			return this.types[key];
		}

		console.warn(key + ' is unsupported');
		return '';
	},

	/**
	 * Get the alias for a given key.
	 *
	 * @param {string} key
	 * @returns {string}
	 */

	_getShortName(key) {
		if (typeof this.aliases[key] !== 'undefined') {
			return this.aliases[key];
		}

		console.warn('Could not find key alias for ' + key);
		return '';
	},

	/**
	 * Get the full name for a given key.
	 *
	 * @param {string} alias
	 * @returns string
	 */

	_getLongName(alias) {
		let longName = '';
		let self = this;

		Object.keys(this.aliases).map(function (key) {
			let value = self.aliases[key];
			if (value === alias) {
				longName = key;
			}
		});

		return longName;
	},

	/**
	 * Parses a timestamp?
	 *
	 * @param {string} value
	 * @returns {string}
	 */

	_parseTimeStamp(value) {
		value = value.trim();

		// Defaults.

		let hour = 0;
		let minute = 0;
		let second = 0;

		// In Javascript, the months start at 0.
		let month = 0;
		let day = 1;

		// Year should always be specified.
		let DateTime = new Date();
		let year = DateTime.getFullYear();

		let timezone = moment(DateTime).format('ZZ');

		DateTime.setSeconds(parseInt(second, 10));

		// It is assumed that this is already in the correct format.

		if (value.length === 19) {
			timezone = value.substr(14, 5);
		}

		// Contains a non-normalized timezone.

		if (value.length === 18) {
			let offsetHours = parseInt(value.substr(14, 2), 10);

			// Nepal has weird timezones.

			let offsetMinutes = parseInt(value.substr(16, 2), 10);

			let Afternoon = new Date();
			Afternoon.setHours(12, 0, 0);

			let Deviation = new Date();
			Deviation.setHours(offsetHours, offsetMinutes, 0);

			let interval = Afternoon.diff(Deviation, 'minute');

			let sign = '+';
			if (interval < 0) {
				sign = '-';
			}

			interval = Math.abs(interval);

			offsetMinutes = interval % 60;
			offsetHours = Math.floor(interval / 60);

			offsetMinutes = offsetMinutes.toString().pad(2, '0', 'left');
			offsetHours = offsetHours.toString().pad(2, '0', 'left');

			timezone = sign + offsetHours + offsetMinutes;
		}

		switch (value.length) {
			case 19:
			case 18:

			case 14:
				second = value.substr(12, 2);

			case 12:
				minute = value.substr(10, 2);

			case 10:
				hour = value.substr(8, 2);

			case 8:
				day = value.substr(6, 2);

			case 6:
				month = value.substr(4, 2);

				// Javascript starts counting at 0 for months.
				month = parseInt(month, 10) - 1;

			case 4:
				year = value.substr(0, 4);
				break;

			default:
				throw new Error('Invalid length for datetime, ' + 'expecting 4, 6, 8, 10, 12, 14, 16, 18 or 19');
		}

		DateTime.setHours(parseInt(hour, 10));
		DateTime.setMinutes(parseInt(minute, 10));
		DateTime.setSeconds(parseInt(second, 10));

		DateTime.setFullYear(parseInt(year, 10));
		DateTime.setDate(parseInt(day, 10));
		DateTime.setMonth(parseInt(month, 10));

		// Equivalent to PHP's YmdHisO.
		let format = 'YYYYMMDDHHmmss';

		let formatted = moment(DateTime).format(format);

		// Add the normalized timezone again.

		return formatted + timezone;
	}
};

export default Parameters;
